import * as d3 from "d3";

export const stackedScaleDomain = (stackedData) => {
  const allValues = stackedData.flat().flatMap((d) => [d[0], d[1]]); // Flatten all start and end values into a single array
  const [min, max] = d3.extent(allValues); // Use d3.extent to find the min and max values in one go
  return [Math.min(min, 0), max]; // Adjust the domain to start at 0 if min > 0, or extend to include negative values
};

export const stackedTransformedData = (data, groups) => {
  return groups.map((category) => {
    const obj = { category };
    data.forEach((dataset) => {
      const valueObj = dataset.values.find((v) => v.x === category);
      obj[dataset.name] = valueObj ? valueObj.y : 0;
    });
    return obj;
  });
};
